// #region imports

// --- Angular
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

// --- RxJs
import { Observable, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';

// --- 3rd Party
import { TranslateService } from '@ngx-translate/core';

// --- HS Code
import {
  UserDetailsModel,
  RegistrationResult,
  LanguageModel,
  Constants
} from '../../../models/';
import {
  RegistrationBaseService,
  OidcService,
  LanguagesBaseService
} from '../../../core/services';
import { AppService } from '../../../core/services/app.service';
import { RegistrationBase } from '../registration-base';
import { ReCaptchaV3Service } from 'ngx-captcha';

// #endregion

@Component({
  selector: 'hs-register-shell',
  templateUrl: './register-shell.component.html',
  styleUrls: ['./register-shell.component.scss']
})
export class RegisterShellComponent extends RegistrationBase implements OnInit, OnDestroy {
  constructor(
    protected router: Router,
    protected registrationService: RegistrationBaseService,
    protected oidcService: OidcService,
    protected appService: AppService,
    protected languageService: LanguagesBaseService,
    protected translate: TranslateService,
    protected reCaptchaV3Service: ReCaptchaV3Service
  ) {
    super(router, registrationService, appService, oidcService, languageService, translate, reCaptchaV3Service);
  }

  ngOnInit() {
    (<any>window).Intercom("boot", {
      app_id: "m7san35s",
      name: "There", 
      email: this.getRandomEmail(),   //"no-reply@heartstyles.com",
      created_at: new Date()
    });
    this._onInit();
  }

  getRandomEmail() {
    let result = '';
    for (var i = 0; i < 5; i++) {
      result += String.fromCharCode(Math.floor(Math.random() * 25) + 97);
    }
    return result + '@heartstyles.com';
  }

  ngOnDestroy() {
    this._onDestroy();
  }
}
